import { graphql } from 'gatsby';

import { Grid2 as Grid, styled } from '@mui/material';

import { ResponsiveGrid } from '@mewa/ui';

import { imagePopulate } from '../../../../libs/strapi-populates';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage, StrapiResponsiveImageData } from './image';

export const HeroImageFragment = graphql`
  fragment HeroImageFragment on STRAPI__COMPONENT_SHARED_RESPONSIVE_IMAGE {
    strapi_component
    ...StrapiImageFragment
  }
`;

export const componentName = 'shared.responsive-image';

export type HeroImageData = StrapiResponsiveImageData & {
  strapi_component: typeof componentName;
};

export type HeroImagePreview = HeroImageData;

export const isHeroImage = (
  component: PossibleContentSections,
): component is HeroImageData => {
  // We reuse the shared responsive image component
  return component.strapi_component === componentName;
};

export const StrapiHeroImage = ({
  imageAlternativeText,
  imageDesktop,
  imageMobile,
}: ComponentProps<HeroImageData>) => {
  return (
    <ResponsiveGrid>
      <Grid size={12}>
        <StyledHeroImage>
          <StrapiImage
            responsiveImage={{
              imageAlternativeText,
              imageDesktop,
              imageMobile,
            }}
          />
        </StyledHeroImage>
      </Grid>
    </ResponsiveGrid>
  );
};

const StyledHeroImage = styled('div')(({ theme }) => ({
  marginBottom: '122px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '44px',
  },
}));

export const config = {
  isComponent: isHeroImage,
  Component: StrapiHeroImage,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  populationParams: imagePopulate.populate,
  componentName,
  mapProperties: (heroImage): HeroImageData | null =>
    heroImage.strapi_component === componentName ? heroImage : null,
};
